export default __webpack_public_path__ + "static/media/up-arrow.1b5fe6b7.svg";